import { render, staticRenderFns } from "./DownloadWhiteIcon.vue?vue&type=template&id=76818010"
import script from "./DownloadWhiteIcon.vue?vue&type=script&lang=js"
export * from "./DownloadWhiteIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports